import React from 'react';
import { Navigate, RouterProvider, createBrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { ROUTE_KEYS } from './utils/constants';
import ALL_ROUTES from './router';
import { ToastContainer } from 'react-toastify';
import { DEFAULT_TOAST_OPTIONS } from '@cokitchen/cokitchen-components';
import UnauthRoute from 'router/UnauthRoute';
import Login from 'pages/auth/login';
import ResetPassword from 'pages/auth/reset-password';
import RoleLayout from 'layouts/role.layout';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.Fragment>
    <ToastContainer {...DEFAULT_TOAST_OPTIONS} />
    <RoleLayout>
      <RouterProvider
        router={createBrowserRouter([
          {
            path: ROUTE_KEYS.LOGIN,
            element: (
              <UnauthRoute>
                <Login />
              </UnauthRoute>
            )
          },

          {
            path: ROUTE_KEYS.RESET_PASSWORD,
            element: (
              <UnauthRoute>
                <ResetPassword />
              </UnauthRoute>
            )
          },
          ...ALL_ROUTES,
          {
            path: '*',
            element: <Navigate to={ROUTE_KEYS.LOGIN} />
          }
        ])}
      />
    </RoleLayout>
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
